import axios from "axios";

// ============================================================
// API BASE URL
// ============================================================

const baseURL =
  process.env.REACT_APP_API_URL;


// ============================================================
// IMAGE BASE URLs
// ============================================================

export const IMAGE_BASE_URL =
  process.env.REACT_APP_IMAGE_URL;

export const DRIVER_IMAGE_URL =
  process.env.REACT_APP_DRIVER_IMAGE_URL;


// ============================================================
// ENVIRONMENT CHECK
// ============================================================

if (!baseURL) {

  console.error(
    "CRITICAL ERROR: REACT_APP_API_URL is not defined."
  );

}

if (!DRIVER_IMAGE_URL) {

  console.warn(
    "WARNING: REACT_APP_DRIVER_IMAGE_URL is not defined."
  );

}


// ============================================================
// AXIOS INSTANCE
// ============================================================

const api = axios.create({

  baseURL: baseURL,

  // VERY IMPORTANT
  // Allows browser to send express-session cookie
  withCredentials: true,

  headers: {
    "Content-Type": "application/json"
  }

});


export default api;
